import React, { useState, useMemo } from 'react';
import { Container, Row, Col, Card, Button, Table, Pagination, Form, InputGroup } from 'react-bootstrap';
import TPinModal from '../../../components/common/TPinModal';
import showToast from '../../../utils/toast';

const ClaimRefund = () => {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [searchQuery, setSearchQuery] = useState('');
  const [showTPinModal, setShowTPinModal] = useState(false);
  const [selectedRefund, setSelectedRefund] = useState(null);

  // Sample refund data
  const refundData = [
    {
      receipt: 'RCP001',
      date: '2024-11-05',
      time: '10:30 AM',
      mobileNumber: '9876543210',
      status: 'Approved',
      remark: 'Transaction failed, amount debited',
      amount: '500',
      beneficiaryName: 'Rajesh Kumar',
      bankOperator: 'HDFC Bank',
      orderId: 'ORD2024110501'
    },
    {
      receipt: 'RCP002',
      date: '2024-11-05',
      time: '09:15 AM',
      mobileNumber: '9123456789',
      status: 'Pending',
      remark: 'Recharge not received',
      amount: '299',
      beneficiaryName: 'Priya Sharma',
      bankOperator: 'Airtel',
      orderId: 'ORD2024110502'
    },
    {
      receipt: 'RCP003',
      date: '2024-11-04',
      time: '06:45 PM',
      mobileNumber: '8765432109',
      status: 'Rejected',
      remark: 'Invalid transaction proof',
      amount: '1000',
      beneficiaryName: 'Amit Patel',
      bankOperator: 'ICICI Bank',
      orderId: 'ORD2024110403'
    },
    {
      receipt: 'RCP004',
      date: '2024-11-04',
      time: '04:20 PM',
      mobileNumber: '9988776655',
      status: 'Approved',
      remark: 'DTH recharge failed',
      amount: '599',
      beneficiaryName: 'Sneha Reddy',
      bankOperator: 'Tata Sky',
      orderId: 'ORD2024110404'
    },
    {
      receipt: 'RCP005',
      date: '2024-11-04',
      time: '02:10 PM',
      mobileNumber: '7654321098',
      status: 'Pending',
      remark: 'Payment gateway issue',
      amount: '750',
      beneficiaryName: 'Vikram Singh',
      bankOperator: 'SBI',
      orderId: 'ORD2024110405'
    },
    {
      receipt: 'RCP006',
      date: '2024-11-03',
      time: '11:30 AM',
      mobileNumber: '9876543211',
      status: 'Approved',
      remark: 'Bill payment not reflected',
      amount: '1200',
      beneficiaryName: 'Anjali Gupta',
      bankOperator: 'Axis Bank',
      orderId: 'ORD2024110306'
    },
    {
      receipt: 'RCP007',
      date: '2024-11-03',
      time: '09:00 AM',
      mobileNumber: '8899776655',
      status: 'Pending',
      remark: 'UPI transaction failed',
      amount: '2500',
      beneficiaryName: 'Rahul Verma',
      bankOperator: 'Paytm',
      orderId: 'ORD2024110307'
    },
    {
      receipt: 'RCP008',
      date: '2024-11-02',
      time: '05:45 PM',
      mobileNumber: '7788996655',
      status: 'Approved',
      remark: 'Mobile recharge not received',
      amount: '199',
      beneficiaryName: 'Neha Joshi',
      bankOperator: 'Jio',
      orderId: 'ORD2024110208'
    },
    {
      receipt: 'RCP009',
      date: '2024-11-02',
      time: '03:20 PM',
      mobileNumber: '9966554433',
      status: 'Rejected',
      remark: 'Insufficient documentation',
      amount: '3500',
      beneficiaryName: 'Suresh Yadav',
      bankOperator: 'PNB',
      orderId: 'ORD2024110209'
    },
    {
      receipt: 'RCP010',
      date: '2024-11-02',
      time: '01:15 PM',
      mobileNumber: '8877665544',
      status: 'Pending',
      remark: 'Fund transfer issue',
      amount: '5000',
      beneficiaryName: 'Kavita Mehta',
      bankOperator: 'Kotak Bank',
      orderId: 'ORD2024110210'
    },
    {
      receipt: 'RCP011',
      date: '2024-11-01',
      time: '04:30 PM',
      mobileNumber: '9876543212',
      status: 'Approved',
      remark: 'Transaction timeout',
      amount: '450',
      beneficiaryName: 'Arun Kumar',
      bankOperator: 'Vi',
      orderId: 'ORD2024110111'
    },
    {
      receipt: 'RCP012',
      date: '2024-11-01',
      time: '02:45 PM',
      mobileNumber: '9123456788',
      status: 'Pending',
      remark: 'AEPS transaction failed',
      amount: '3000',
      beneficiaryName: 'Pooja Singh',
      bankOperator: 'BOB',
      orderId: 'ORD2024110112'
    },
    {
      receipt: 'RCP013',
      date: '2024-11-01',
      time: '11:20 AM',
      mobileNumber: '8765432108',
      status: 'Approved',
      remark: 'Network issue during transaction',
      amount: '899',
      beneficiaryName: 'Deepak Sharma',
      bankOperator: 'Dish TV',
      orderId: 'ORD2024110113'
    },
    {
      receipt: 'RCP014',
      date: '2024-10-31',
      time: '03:55 PM',
      mobileNumber: '9988776656',
      status: 'Rejected',
      remark: 'Transaction already refunded',
      amount: '650',
      beneficiaryName: 'Ritu Agarwal',
      bankOperator: 'BSNL',
      orderId: 'ORD2024103114'
    },
    {
      receipt: 'RCP015',
      date: '2024-10-31',
      time: '01:10 PM',
      mobileNumber: '7654321099',
      status: 'Approved',
      remark: 'Amount deducted twice',
      amount: '299',
      beneficiaryName: 'Manoj Tiwari',
      bankOperator: 'Airtel',
      orderId: 'ORD2024103115'
    },
    {
      receipt: 'RCP016',
      date: '2024-10-30',
      time: '05:25 PM',
      mobileNumber: '9876543213',
      status: 'Pending',
      remark: 'Service not activated',
      amount: '1500',
      beneficiaryName: 'Swati Desai',
      bankOperator: 'HDFC Bank',
      orderId: 'ORD2024103016'
    },
    {
      receipt: 'RCP017',
      date: '2024-10-30',
      time: '02:40 PM',
      mobileNumber: '8899776656',
      status: 'Approved',
      remark: 'Payment processing error',
      amount: '799',
      beneficiaryName: 'Sanjay Rao',
      bankOperator: 'Sun Direct',
      orderId: 'ORD2024103017'
    },
    {
      receipt: 'RCP018',
      date: '2024-10-30',
      time: '11:15 AM',
      mobileNumber: '7788996656',
      status: 'Pending',
      remark: 'Beneficiary not found',
      amount: '2200',
      beneficiaryName: 'Meera Nair',
      bankOperator: 'ICICI Bank',
      orderId: 'ORD2024103018'
    },
    {
      receipt: 'RCP019',
      date: '2024-10-29',
      time: '04:50 PM',
      mobileNumber: '9966554434',
      status: 'Rejected',
      remark: 'Claim period expired',
      amount: '950',
      beneficiaryName: 'Karan Khanna',
      bankOperator: 'Jio',
      orderId: 'ORD2024102919'
    },
    {
      receipt: 'RCP020',
      date: '2024-10-29',
      time: '12:30 PM',
      mobileNumber: '8877665545',
      status: 'Approved',
      remark: 'Transaction cancelled by user',
      amount: '349',
      beneficiaryName: 'Divya Saxena',
      bankOperator: 'Videocon D2H',
      orderId: 'ORD2024102920'
    }
  ];

  // Filter data based on search
  const filteredData = useMemo(() => {
    let filtered = [...refundData];

    if (searchQuery) {
      filtered = filtered.filter(row =>
        Object.values(row).some(value =>
          String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
    }

    return filtered;
  }, [searchQuery]);

  // Pagination logic
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentData = filteredData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(filteredData.length / rowsPerPage);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Generate pagination items
  const getPaginationItems = () => {
    const items = [];
    const maxVisible = 5;
    
    if (totalPages <= maxVisible) {
      for (let i = 1; i <= totalPages; i++) {
        items.push(
          <Pagination.Item
            key={i}
            active={i === currentPage}
            onClick={() => handlePageChange(i)}
          >
            {i}
          </Pagination.Item>
        );
      }
    } else {
      if (currentPage <= 3) {
        for (let i = 1; i <= 4; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      } else if (currentPage >= totalPages - 2) {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = totalPages - 3; i <= totalPages; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
      } else {
        items.push(
          <Pagination.Item key={1} onClick={() => handlePageChange(1)}>
            1
          </Pagination.Item>
        );
        items.push(<Pagination.Ellipsis key="ellipsis-start" disabled />);
        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          items.push(
            <Pagination.Item
              key={i}
              active={i === currentPage}
              onClick={() => handlePageChange(i)}
            >
              {i}
            </Pagination.Item>
          );
        }
        items.push(<Pagination.Ellipsis key="ellipsis-end" disabled />);
        items.push(
          <Pagination.Item
            key={totalPages}
            onClick={() => handlePageChange(totalPages)}
          >
            {totalPages}
          </Pagination.Item>
        );
      }
    }
    
    return items;
  };

  const handleRefundClick = (refund) => {
    setSelectedRefund(refund);
    setShowTPinModal(true);
  };

  const handleVerifyTpin = async ({ tpin: tpinValue }) => {
    if (!selectedRefund) {
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 800));

    showToast.success(`Refund request for receipt ${selectedRefund.receipt} submitted successfully.`);

    setShowTPinModal(false);
    setSelectedRefund(null);
  };

  const handleCloseTPinModal = () => {
    setShowTPinModal(false);
    setSelectedRefund(null);
  };

  return (
    <Container fluid className="claim-refund-page p-4">
      {/* Refund Table */}
      <Row>
        <Col>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-bottom" style={{ padding: '16px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <h5 className="mb-0" style={{ fontWeight: 600, color: '#2c2268' }}>
                    <i className="bi bi-list-ul me-2"></i>
                    Claim Refund
                  </h5>
                </Col>
                <Col md={6} className="d-flex justify-content-end">
                  <InputGroup style={{ maxWidth: '300px' }}>
                    <InputGroup.Text style={{ backgroundColor: '#f8f9fa', border: '1px solid #ddd' }}>
                      <i className="bi bi-search"></i>
                    </InputGroup.Text>
                    <Form.Control
                      type="text"
                      placeholder="Search..."
                      value={searchQuery}
                      onChange={(e) => {
                        setSearchQuery(e.target.value);
                        setCurrentPage(1);
                      }}
                      style={{ border: '1px solid #ddd' }}
                    />
                  </InputGroup>
                </Col>
              </Row>
            </Card.Header>
            <Card.Body className="p-0">
              <div className="table-responsive">
                <Table hover className="mb-0">
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px', width: '110px' }}>
                        Action
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Receipt
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Date
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Time
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Mobile_Number
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Status
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Remark
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Amount
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Beneficiary_Name
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Bank/Operator
                      </th>
                      <th style={{ padding: '12px 16px', fontWeight: 600, color: '#555', borderBottom: '2px solid #dee2e6', fontSize: '14px' }}>
                        Order ID
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.length > 0 ? (
                      currentData.map((refund, index) => (
                        <tr key={index} style={{ transition: 'background-color 0.2s' }}>
                          <td style={{ padding: '12px 16px' }}>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              onClick={() => handleRefundClick(refund)}
                              style={{ padding: '6px 10px', fontSize: '12px', lineHeight: 1.4 }}
                            >
                              Refund
                            </Button>
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '14px', fontWeight: 600 }}>
                            {refund.receipt}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px' }}>
                            {refund.date}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px' }}>
                            {refund.time}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '14px', fontWeight: 500 }}>
                            {refund.mobileNumber}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px' }}>
                            {refund.status}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px', maxWidth: '200px' }}>
                            {refund.remark}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '14px', fontWeight: 600 }}>
                            ₹{refund.amount}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px' }}>
                            {refund.beneficiaryName}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#666', fontSize: '14px' }}>
                            {refund.bankOperator}
                          </td>
                          <td style={{ padding: '12px 16px', color: '#333', fontSize: '14px', fontWeight: 500 }}>
                            {refund.orderId}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center py-4" style={{ color: '#999' }}>
                          No refund requests found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card.Body>
            <Card.Footer className="bg-white border-top" style={{ padding: '12px 24px' }}>
              <Row className="align-items-center">
                <Col md={6}>
                  <div style={{ fontSize: '14px', color: '#666' }}>
                    Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, filteredData.length)} of {filteredData.length}
                  </div>
                </Col>
                <Col md={6}>
                  <Pagination className="mb-0 justify-content-end">
                    <Pagination.First 
                      onClick={() => handlePageChange(1)} 
                      disabled={currentPage === 1}
                    />
                    <Pagination.Prev 
                      onClick={() => handlePageChange(currentPage - 1)} 
                      disabled={currentPage === 1}
                    />
                    {getPaginationItems()}
                    <Pagination.Next 
                      onClick={() => handlePageChange(currentPage + 1)} 
                      disabled={currentPage === totalPages}
                    />
                    <Pagination.Last 
                      onClick={() => handlePageChange(totalPages)} 
                      disabled={currentPage === totalPages}
                    />
                  </Pagination>
                </Col>
              </Row>
            </Card.Footer>
          </Card>
        </Col>
      </Row>

      <TPinModal
        show={showTPinModal}
        onHide={handleCloseTPinModal}
        onVerify={handleVerifyTpin}
        title="Verify Refund"
        message={selectedRefund ? `Enter your T-PIN to submit refund request for receipt ${selectedRefund.receipt}.` : 'Enter your T-PIN to continue.'}
        confirmLabel="Submit"
      />

      {/* Custom Styles */}
      <style jsx="true">{`
        .claim-refund-page {
          background-color: #fff;
          min-height: calc(100vh - 100px);
        }

        .table tbody tr:hover {
          background-color: #f8f9fa;
        }

        .pagination .page-link {
          color: #0d6efd;
          border: 1px solid #dee2e6;
          padding: 6px 12px;
          font-size: 14px;
        }

        .pagination .page-item.active .page-link {
          background-color: #0d6efd;
          border-color: #0d6efd;
          color: white;
        }

        .pagination .page-link:hover {
          background-color: #e7f1ff;
          border-color: #0d6efd;
          color: #0d6efd;
        }

        .pagination .page-item.disabled .page-link {
          color: #6c757d;
          pointer-events: none;
          background-color: #fff;
          border-color: #dee2e6;
        }

        @media (max-width: 768px) {
          .table-responsive {
            overflow-x: auto;
          }

          .pagination {
            font-size: 12px;
          }
        }
      `}</style>
    </Container>
  );
};

export default ClaimRefund;

